import React, { useEffect, useState } from "react";
import { Select, MenuItem, Box, Modal, Typography, Slider, Button, Link, Dialog, DialogTitle,
    DialogContent,
    DialogActions,
    useMediaQuery,
    IconButton,
    useTheme } from '@mui/material';

import AudioRecorder from "../Archive/audioWrap/audioWrap";
import AudioPreview from "./AudioPreview";
import { Close } from '@mui/icons-material';
import CustomAudioPlayer from "../Archive/audioWrap/AudioPreview";
const CustomDropdown = (props) => {
    const {
        label,
        value,
        onChange,
        isDisabled,
        id,
        options,
        fileAttributes,
        setFileAttributes,
        resetFormdata
      } = props;
      console.log(resetFormdata, "id here is this")
  // const [selectedOption, setSelectedOption] = useState("");
  const [files, setFiles] = useState([]);
  const [fontSize, setFontSize] = useState(16);
  const [showModal, setShowModal] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedOption, setSelectedOption] = useState(null);
  const [sessionOption, setSessionOption] = useState(null);

  const handleSliderChange = (event) => {
    setFontSize(event.target.value);
  };
  
  const modalClose = () => {
    setShowModal(false);
    setFontSize(16); // Reset font size when closing the modal
  };
  const handleLeftButtonClick = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 8));
  };

  const handleRightButtonClick = () => {
    setFontSize((prevSize) => Math.min(prevSize + 2, 40));
  };

  const handleDropdownChange = (event) => {
    
    const selectedQuestion = event.target.value;
    console.log(selectedQuestion);
    const option = options.enumOptions.find((option) => option.value.question === selectedQuestion);
    console.log(option);
    setSelectedOption(option.value);
    setSessionOption(option.value);
    console.log(selectedOption, sessionOption);
    // onChange(option.value);
    if (!resetFormdata) {
      sessionStorage.setItem("past", option.value.qid);
    }
    console.log(selectedOption, sessionOption);
    // setShowModal(true);
  };

  const handleRecordClick = () => {
    // Logic to handle recording
    console.log("Recording started");
  };
  const isFileValid = (file) => {
    const nameParts = file.name.split(".");
    const fileExt = nameParts[nameParts.length - 1];
    const fileType = file.type?.split("/")[0];
    return true;
  };

  const handleRedoClick = () => {
    setShowModal(true);
  }

  const handleDiscard = () => {
    fileAttributes[id] = null;
    console.log(fileAttributes)
  }
  const handleChange = (inpFiles) => {
    // change the file name, add the question id to it.
    const updatedFile = new File([inpFiles[0]], value.qid+"_"+inpFiles[0].name);
    setFiles([updatedFile]);
    console.log(updatedFile);
    
    // form data getting
    setFileAttributes((prevState) => {
      prevState[id] = [updatedFile];
      return prevState;
    });
    setTimeout(() => {
      setShowModal(false);
    }, 2000);
    
    console.log(fileAttributes, fileAttributes[id][0])
  };

  

  useEffect(() => {

    if (isMobile) {
      setFontSize(24);
    } else {
      setFontSize(36);
    }
    console.log(sessionOption, " <- session option", selectedOption, "<- selected option");
    let question = sessionStorage.getItem("past");
    console.log(question);
    if (!resetFormdata && question && sessionOption===null && selectedOption===null) {

      const option = options.enumOptions.find((option) => option.value.qid === (parseInt(question, 10)%(options.enumOptions.length))+1);
    console.log(sessionOption, option);
    setSelectedOption(option.value);
    setSessionOption(option.value);
    // onChange(option.value);
    sessionStorage.setItem("past", option.value.qid);
    }
  }, [])

  useEffect(() => {
    if (selectedOption?.qid) {
      setShowModal(true);
      onChange(selectedOption);
    }
  }, [selectedOption])


  return (
    <div>
  <Box>
  <Select
        value={selectedOption ? selectedOption?.question : ''}
        onChange={handleDropdownChange}
        displayEmpty
        fullWidth
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getcontentanchorel: null,
        }}
      >
        <MenuItem value="" disabled>
          {isMobile ? 'Select' : value ? value.question : 'Select a text to record'}
        </MenuItem>
        {options.enumOptions.map((option) => (
          <MenuItem key={option.value.qid} value={option.value.question}>
            <Typography variant={isMobile ? 'subtitle2' : 'body1'}>
              {option.value.question}
            </Typography>
          </MenuItem>
        ))}
      </Select>
  <div style={{ display: 'block', marginTop: '16px' }}>
    {fileAttributes[id] ? (
      
        <CustomAudioPlayer 
          audioFile={fileAttributes[id][0] ? URL.createObjectURL(fileAttributes[id][0]) : ''} 
          redoFunction={handleRedoClick}
          showSave={false}
            showControl={true}
            handleSave={'null'}
            sliderColor={'success'}
          />
        
    ) : (
      <Typography variant="body2" color="textSecondary">
        No file attached
      </Typography>
    )}
  </div>

</Box>

{value && (
  <Dialog
  open={showModal}
  maxWidth={isMobile ? 'sm' : 'md'}
  fullWidth
  PaperProps={{
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      p: isMobile ? '10px' : '20px', // Reduce padding for mobile screens
      backgroundColor: '#FFF',
      borderRadius: '4px',
    },
  }}
>
  <DialogTitle>
    Q{value.qid}
    <IconButton
      aria-label="close"
      onClick={modalClose}
      sx={{
        position: 'absolute',
        top: '8px',
        right: '8px',
      }}
    >
      <Close />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers sx={{ m: isMobile ? '0px' : '16px', p: isMobile ? '10px' : '20px', width:'100%'}}> {/* Remove margin for mobile screens */}
    <Typography
      variant="body1"
      style={{
        fontSize: `${fontSize}px`,
        maxHeight: '200px',
        overflowY: 'auto',
        marginBottom: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {value.question}
    </Typography>
    {/* <Slider
      value={fontSize}
      min={12}
      max={60}
      step={2}
      onChange={handleSliderChange}
      sx={{ mt: isMobile ? '10px' : '16px' }} // Reduce margin-top for mobile screens
    /> */}
    <Box display="flex" width="100%" paddingY={'30px'} paddingX={'200px'}>
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={handleLeftButtonClick}
        style={{
          fontSize: `${16}px`,
          width: '50%',
          background: '#E9EDF1',
          borderTopRightRadius: '0',
          borderBottomRightRadius: '0',
          color: 'black',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        A-
      </Button>
      <Button
        size="large"
        variant="contained"
        color="primary"
        onClick={handleRightButtonClick}
        style={{
          fontSize: `${32}px`,
          width: '50%',
          background: '#E9EDF1',
          borderTopLeftRadius: '0',
          borderBottomLeftRadius: '0',
          color: 'black',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        A+
      </Button>
    </Box>
    <AudioRecorder 
      handleChange={handleChange} 
      audioFile={files[0]} sx={{ mt: isMobile ? '10px' : '16px' }} 
      
    /> {/* Reduce margin-top for mobile screens */}
  </DialogContent>
</Dialog>

)}
</div>
  );
};

export default CustomDropdown;
